export enum ContentBlockIds {
  MainContent = 'main',
  FooterContent = 'footer',
}
